/*! Tablesaw - v3.0.9 - 2018-02-14
 * https://github.com/filamentgroup/tablesaw
 * Copyright (c) 2018 Filament Group; Licensed MIT */
(function (win) {
    "use strict";

    // DOM-ready auto-init of plugins.
    // Many plugins bind to an "enhance" event to init themselves on dom ready, or when new markup is inserted into the DOM
    // Use raw DOMContentLoaded instead of shoestring (may have issues in Android 2.3, exhibited by stack table)
    if (!("Tablesaw" in win)) {
        throw new Error("Tablesaw library not found.");
    }
    if (!("init" in Tablesaw)) {
        throw new Error("Your tablesaw-init.js is newer than the core Tablesaw version.");
    }

    Tablesaw.init();
})(typeof window !== "undefined" ? window : this);

(function () {
    var $window = $(window);
    var height = $window.height();
    var width = $window.width();
    var $floatmenu = $('.section-support-menu:not(.noscroll), .search-menu');
    var $topmenu = $('.section-float-menu');
    var offset = 0;
    var $mobile = false;
    var $device;
    var loaded = false;
    var maxWidth = $('.dealer-map').width();
    var maxHeight = $('.dealer-map').height();
    var PropertiesHeight = $('.section-properties').css('height');
    var $searchfield;

    newCart = {
        options: {
            template: '<li data-id="{id}"><div class="menu--title"><span class="mnuCart">{label}</span><span class="mnuCart licence-type">{type}</span></div><div class="menu--price"><span class="mnuCart ">{price}</span><a href="#" class="close"></a></div></li>',
            defaultPriceTemplate: '<strong>{price} {currency}</strong>',
            priceTemplate: '<span>{price} {currency}</span>',
            defaultCurrency: '',
            currencies: [],
            apiUrl: '',
            networkMultiplier: 30,
            leaseMultiplier: 40
        },
        init: function () {
            var self = this;
            this.cart = {};
            this.element = $('#cartDropdown');
            this.mobileCart = $('#mobileCart ul.cart-items');

            this.options.defaultCurrency = this.element.attr('data-currency') || '';
            this.options.apiUrl = this.element.attr('data-api-url');

            this.emptyCart = emptyCart;

            this.content = $('.cart-items');

            this.silent = true;
            this.isActive = false;

            // this.counts = this.element.find('.count');
            this.counts = $('#cartCount');
            this.timer = null;
            var data = this.readCartPrograms();

            if (data) {
                this.render(data);
            }

            window.addEvent('addToCart', function (url) {
                self.silent = false;
                $('html, body').animate({ scrollTop: 0 });
            });

            window.addEvent('removeFromCart', function (url) {
                self.silent = true;
            });
        },
        addToCart: function (qty) {
            var self = this;
            this.cart = this.readCartPrograms();
            var result = [];
            if (this.cart) {
                result = $.grep(this.cart, function (e) { return e.id == programApi.id; });
            }
            var pr = programApi;
            if (result.length) {
                pr = result[0];
            } else {
                this.cart.push(pr);
            }

            pr[qty] = (Number(pr[qty]) || 0) + 1;

            this.writeCartData();
            return this;
        },
        getCart: function () {
            var cart = JSON.parse(window.localStorage.getItem('cart'));

            if (cart == null) {
                return this.emptyCart;
            }
            if (cart.version != this.emptyCart.version) {
                this.writeEmptyCartData();
                return this.emptyCart;
            }
            return cart;
        },
        readCartPrograms: function () {
            var self = this;
            var cart = this.getCart();
            if (cart.programs.length < 1) {
                return [];
            }
            return cart.programs.sort(function (a, b) { return b.sortOrder - a.sortOrder })

        },

        writeCartData: function () {
            var self = this;
            var cart = this.getCart();

            cart.programs = this.cart;
            cart.cartStep = 1;
            window.localStorage.setItem('cart', JSON.stringify(cart));

            return this;
        },
        writeEmptyCartData: function () {
            var self = this;
            var cart = this.emptyCart;
            window.localStorage.setItem('cart', JSON.stringify(cart));
            return this;
        },
        deleteCartItem: function (id) {
            // var self = this;
            return this;
            this.cart = this.readCartPrograms();
            this.cart = $.grep(this.cart, function (e) { return e.id != id; });
            this.writeCartData();
            return this;
        },
        render: function (data) {
            var self = this;
            var buffer = [];
            var types = ['cloud_perpetual_quantity', 'cloud_time_quantity'];
            var count = 0;


            if (typeOf(data) === 'array' && data.length) {
                data.each(function (item, key) {
                    types.each(function (type, k) {
                        var no = Number(item[type]) || 0
                        if (no > 0) {
                            count = count + no;
                            buffer.push(self.options.template.substitute({
                                type: cartToolbarTranslations[type],
                                id: item.id,
                                label: item[type] + "x" + ' ' + item.name,
                                price: self.createPrice(item, type),
                            }));
                        }
                    });

                });

                if (count > 0) {
                    $('body').find(".cartCount").css("display", "block").html(count);
                }


                this.element.addClass('cart-full');
                this.mobileCart.addClass('cart-full');
                this.content.removeClass('hidden');
                this.content.css('display', '');
                $('div.menu.cart .order').removeClass('hidden');
                $('div.menu.cart .empty-cart').removeClass('hidden');
                $('div.menu.cart .emptycart').addClass('hidden');
                this.element.find('.menu--footer').css('position', 'relative');
            } else {
                this.element.removeClass('cart-full');
                this.mobileCart.removeClass('cart-full');
                this.content.addClass('hidden');
                $('div.menu.cart .order').addClass('hidden');
                $('div.menu.cart .empty-cart').addClass('hidden');
                $('div.menu.cart .emptycart').removeClass('hidden');
                this.element.find('.menu--footer').css('position', 'absolute');
            }

            this.content.html(buffer.join(''));

            this.mobileCart.html(buffer.join(''));

            if (!this.silent) {
                this.open();
                this.timer = this.close.delay(3000, this);
            }
        },

        toggle: function () {
            if (this.element.hasClass('activex')) {
                this.close();
            } else {
                this.open();
            }
            return this;
        },

        open: function () {
            clearTimeout(this.timer);
            $('.thismenuopened').removeClass('thismenuopened');
            $('#main-menu .menu-label.icon-cart').addClass('thismenuopened');
            adaptMenu();
            this.element.addClass('activex');

            return this;
        },

        close: function () {
            if (!this.isActive) {
                this.element.removeClass('activex');
                $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
                $('.thismenuopened').removeClass('thismenuopened');
            }
            return this;
        },
        searchItem: function (array, key, prop) {
            prop = (typeof prop === 'undefined') ? 'name' : prop;

            for (var i=0; i < array.length; i++) {
                if (array[i][prop] === key) {
                    return array[i];
                }
            }
        },

        createPopupPrice: function(id, type) {
            var cart = this.getCart();
            var item = this.searchItem(cart['programs'],  id, 'predator')
            var value = this.getItemPrice(item, type);
            return this.priceFormat(value);
        },
        createPrice: function (item, type) {
            var value = this.getItemPrice(item, type) * (Number(item[type]) || 0);
            return this.priceFormat(value);
        },
        priceFormat: function (price) {
            price = Number(price) || 0;

            var decimalCount = 0;

            var decimal = decPoint;
            var thousands = thousandsSep;

            var i = parseInt(price = Math.abs(Number(price) || 0).toFixed(decimalCount)).toString();
            var j = (i.length > 3) ? i.length % 3 : 0;

            var value = (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(price - i).toFixed(decimalCount).slice(2) : "");
            var c = this.options.defaultCurrency.toLowerCase();
            return currencySettings[c].prefix + value + currencySettings[c].suffix;
        },
        getItemPrice: function (item, qty) {
            var currency = this.options.defaultCurrency;
            var basePrice = Number(item['price_list'][currency] || 0);
            var price = 0;
            var cart = this.getCart();

            if (qty === 'cloud_time_quantity') {
                price = Number(item['lease_price_list'][currency] || 0);
            } else {
                price = basePrice || 0;
            }

            price = price * (parseInt(cart.priceCoefficient) / 100) || 0;

            return Math.trunc(price);
        },

    };


    if ($floatmenu.length) { offset = parseInt($floatmenu.offset().top) - 110; }

    $(window).resize(function () {
        height = $window.height();
        width = $window.width();
        adapt();
    });

    /*-- STICKY MENUS ON FEW PAGES --*/
    $(window).bind('scroll', function () {
        if ($floatmenu.length && ($floatmenu.outerHeight(true) < $(window, screen).height())) {
            if (($(window).scrollTop() > offset) && ($(window).scrollTop() + $window.height()) < ($(document).height() - 270)) {
                if ($(window).scrollTop() - offset - 100 > 0) {
                    $floatmenu.css('position', 'absolute').css('top', ($(window).scrollTop() - offset - 100) + 'px');
                } else {
                    $floatmenu.css('position', 'absolute').css('top', '0px');
                }
            }
        } else if ($floatmenu.outerHeight(true) > $(window, screen).height()) {
            $floatmenu.css('position', 'absolute').css('top', 0);
        }
        $('.support-container__onlineHelp').css('min-height', $floatmenu.outerHeight(true) + 'px');
    });


    /*-- CART ADDING AND REMOVING LISTENERS --*/
    $(document).on('click', '.buyLicenseLink', function (event) {
        event.preventDefault();
        loadCartItems($(this).attr('data-program'), $(this).attr('data-type'), 'add');

        $('#addedToCartLicence').html(cartToolbarTranslations[$(this).attr('data-type')]);

        var price = newCart.createPopupPrice($(this).attr('data-program'), $(this).attr('data-type'));

        $('#addedToCartPrice').html(price);
        $('#addedToCart').modal('show');
    });

    $(document).on('click', '.removeCartButton', function (event) {
        event.preventDefault();
        var parentLi = $(this).parent().parent();
        loadCartItems($(this).attr('data-program'), $(this).attr('data-program-type'), 'remove');
        parentLi.slideUp(100);
    });



    /*-- GLOBAL LISTENERY --*/

    $(document).on('mouseenter', '.popup-info', function () {
        var $panel = $(this).parent().find('.content').hide();
        $panel.addClass('popup');
    });


    $(document).on('click', '.popup-info', function () {
        return false;
    });


    $(document).on('mouseout', '.popup-info', function () {
        var $panel = $(this).parent().find('.content').hide();
        $panel.removeClass('popup');
    });

    $(document).on('click', '.mobile-menu.mobile--cart a', function (event) {
        $(this).addClass('enable');
        $(".mobile-menu.mobile--main a").removeClass("icon-mobile-menu-2");
        $(".mobile-menu.mobile--main a").addClass("icon-close");
    });
    $(document).on('click', '.mobile-menu.mobile--search a', function (event) {
        $(this).addClass('enable');
        $(".mobile-menu.mobile--main a").removeClass("icon-mobile-menu-2");
        $(".mobile-menu.mobile--main a").addClass("icon-close");
    });
    $(document).on('click', '.mobile-menu.mobile--main a', function (event) {
        $(this).addClass('enable');
        $(".mobile-menu.mobile--main a").removeClass("icon-mobile-menu-2");
        $(".mobile-menu.mobile--main a").addClass("icon-close");
    });
    $(document).on('click', '.mobile-menu.mobile--login a', function (event) {
        $(this).addClass('enable');
        $(".mobile-menu.mobile--main a").removeClass("icon-mobile-menu-2");
        $(".mobile-menu.mobile--main a").addClass("icon-close");
    });



    /*-- #SEARCH SCROLL TO FOUND ITEM BY MENU CONTROLLER --*/
    $(document).on('click', '.search-menu a', function (event) {
        event.preventDefault();
        var actualtab = $(".tabs-generated li.active a").attr('href').replace('#', '');;
        var offset = $(this).attr('href').replace('#', '');
        offset = parseInt($('#' + actualtab + "-" + offset).offset().top)
        $("html, body").animate({ scrollTop: (offset + 20) + 'px' }, 800);
    });


    /*-- #SOLUTIONS ITEM PROPERTIES ROLLDOWN --*/
    $(document).on('click touchend', '.solution-list-item-link a', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('rolled')) {
            $(this).parent().parent().find('.submenu').stop().slideDown(100);
            $(this).addClass('rolled');
        } else {
            $(this).parent().parent().find('.submenu').stop().slideUp(100);
            $(this).removeClass('rolled');
        }
    });


    /*-- #FORM SHOW HIDDEN INFO MENU --*/
    $(document).on('click touchend', '.form-toggle', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('rolled')) {
            $(this).parent().parent().next('.form-slide').show();
            $(this).addClass('rolled');
        } else {
            $(this).parent().parent().next('.form-slide').hide();
            $(this).removeClass('rolled');
        }
    });

    $(document).on('mouseenter', '.form-toggle', function (event) {
        $(this).parent().parent().next('.form-slide').show();
        $(this).addClass('rolled');
    });
    $(document).on('mouseleave', '.form-toggle', function (event) {
        $(this).parent().parent().next('.form-slide').hide();
        $(this).removeClass('rolled');
    });


    /*-- #VERSIONS IF LISTS HAVE SUBLISTS TELL CSS NOT SHOW ARROW --*/
    /* if($('body').hasClass('versions')){
        $('.news-item-content ul li:has(ul)').addClass('has_sub');
     }
 */

    /*-- #SOLUTIONS ITEM PROPERTIES ROLLDOWN --*/
    $(document).on('click touchend', '.faq dt', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('rolled')) {
            $(this).next('dd').addClass('rolled').show()
            $(this).addClass('rolled');
        } else {
            $(this).next('dd').removeClass('rolled').hide();
            $(this).removeClass('rolled');
        }
    });

    /*-- #TECHNICAL SUPPORT FORM SEND HEADER TO DOWNLOAD FILE IMMEDIATELY --*/
    $(document).on('submit', '#form-update-tool', function (event) {
        event.preventDefault();
        var location = $(this).find('input[name="type"]').val();
        if (location) {
            window.location = location;
        } else {
            window.location = $(this).find('select').val();
        }

    });

    /*-- #SOLUTIONS ITEM PROPERTIES ROLLDOWN --*/
    $(document).on('click touchend', '.toggler, .Pricetoggler', function (event) {
        event.preventDefault();
        var product = $(this).parent().attr('data-product');

        if (!$(this).hasClass('rolled')) {
            $('[id^="title-' + product + '"]').addClass('rolled');
            $('[id^="title-' + product + '"] span').addClass('rolled');
            $('[id^="slide-' + product + '"]').addClass('rolled');
            $('[id^="slide-' + product + '"]').css('display', 'block');

            $(this).parent().next('.slide').stop().slideDown(400);
            $(this).find('em').fadeOut();
            $('[id^="em-' + product + '"]').css('display', 'none');
            $(this).parent().next().find('.tablesaw').tablesaw().data("tablesaw").refresh();

            //        setTimeout(function(){ $(this).parent().next().find('.tablesaw').tablesaw().data("tablesaw").resize(); }, 100);

        } else {
            $(this).parent().next('.slide').removeClass('rolled').stop().slideUp(400);
            $(this).find('em').fadeIn()
            $(this).removeClass('rolled');
            $(this).parent().removeClass('rolled');

            $('[id^="title-' + product + '"]').removeClass('rolled');
            $('[id^="title-' + product + '"] span').removeClass('rolled');
            $('[id^="slide-' + product + '"]').removeClass('rolled');
            $('[id^="em-' + product + '"]').css('display', '');
            $('[id^="slide-' + product + '"]').css('display', '');
        }
    });

    /*-- CLOSE OPENED SLIDE HELPERS ON MOBILE --*/
    $('.content').on('touchend', function (event) {
        if ($('.form-slide').length) {
            $('.form-slide').hide();
        }
    });


    /*-- REPLACE <BREAK> IN PROPERTIES --*/
    function adaptProperties() {
        if ($('body').hasClass('product') && !$('body').hasClass('uvod')) {
            var $propertiescol = $('.section-properties .ulholder');
            var $break = $('.section-properties .ulholder').find('break');
            if ($break.length) {
                $break.html('<p class="properties-next"><a href="#">' + $('.properties-label').html() + '</a></p>');
                $oldheight = ($break.offset().top - $propertiescol.offset().top + 70) + 'px';
                $propertiescol.css('height', $oldheight);
            }
        }
    }


    /*-- #PRODUCT PROPERTIES ROLL DOWN --*/
    $(document).on('click touchend', '.properties-next a', function (event) {
        event.preventDefault();
        if (width > 767) {
            $('.section-properties .ulholder').css('height', PropertiesHeight);
        } else {
            $('.section-properties .ulholder').css('height', 'auto');
        }

        $(this).hide();
    });


    /*-- CHANGING LANGUAGE BY SELECT ON #VIDEO-ITEMS --*/
    $(document).on('change', '#video .form-language-selector', function (event) {
        $('.form-language-select').submit();
    });


    /*-- SHOW OTHER COUNTRIES SELECT ON #DEALER PAGE -*/
    $(document).on('click', '#prodejci .othercountries, #aboutus .othercountries', function (event) {
        event.preventDefault();
        $(this).parent().hide();
        $(".dealer-card .select").css('display', 'block');
    });

    /*-- CLOSING ALL MENUS AND PROPER ICON SWITCHING ON SMALLER DEVICES --*/
    $(document).on('click touchstart tap touch touchend', '#mm-blocker', function (event) {
        checkClosing();
        $('.help-menu-mobile').removeClass('active');
    });

    if (window.location.hash) {
        showtab();

    }

    $(window).bind('hashchange', function () {
        if (window.location.hash != '#' && window.location.hash != '') { showtab(); }
    });

    function showtab() {
        if (!$('body').hasClass('zakaznici') && !$('body').hasClass('testimonials')) {
            var href = window.location.hash.replace('#', '');
            var package = '';
            var product = '';
            if ($('body').hasClass('faq')) {
                hrefArray = href.split('_');
                if (hrefArray.length == 3) {
                    href = hrefArray[2];
                    product = hrefArray[0];
                    package = hrefArray[1];
                } else if (hrefArray.length == 2) {
                    href = hrefArray[1];
                    product = hrefArray[0];
                } else if (hrefArray.length == 1 && href.length > 3) {
                    product = href;
                    currency = $('.section-news-tabmenu ul li a:nth-child(1)').attr('href');
                    if (currency !== undefined) {
                        href = currency.substring(1, currency.length);
                    }

                }

                if (product) {
                    $('[id^="title-' + product + '"]').addClass('rolled');
                    $('[id^="title-' + product + '"] span').addClass('rolled');
                    $('[id^="slide-' + product + '"]').addClass('rolled');
                    $('[id^="slide-' + product + '"]').css('display', 'block');
                    $('[id^="em-' + product + '"]').css('display', 'none');

                    if ($('#title-' + product + '-' + href).length) {
                        $("html, body").animate({ scrollTop: $('#title-' + product + '-' + href).offset().top }, 800);
                    }
                }
            }

            $('.section-news-tabmenu li, .section-news-nav li, .dealer-map li').removeClass('active');
            $('a[href$="' + href + '"]').parent().addClass('active');
            $('.tab-panel, .section-timeline, .continent-tab, .search-tab').addClass('hidden');
            $('.search-menu ul').addClass('hidden');
            $('.search-menu ul#list-' + href).removeClass('hidden');
            $('body').find('#' + href).removeClass('hidden');
            $('.tablesaw').each(function () {
                if ($(this).is(':visible'))
                    $(this).tablesaw().data("tablesaw").refresh()
            });

            //show on mobile selected product
            if (package && product) {

                while ($("#pkg-" + package + '-' + href).css("display") === "none") {
                    $("#tablesaw-" + product + '-' + href).trigger("tablesawnext.swipetoggle");
                }
                var index = $("#pkg-" + package + "-" + href).index();

                $('[id^="tablesaw-' + product + '"]').each(function () {
                    var id = $(this).attr('id');
                    if (product == 'geo5') {
                        var color1 = "#DDFFCE";
                        var color2 = "#E2F3DB";
                    } else {
                        var color1 = "#DAF2FD";
                        var color2 = "#D6E8F1";
                    }
                    $("#" + id + " th:nth-child(" + (index + 1) + ")").css('background-color', color1);
                    $("#" + id + " td:nth-child(" + (index + 1) + "):odd:lt(-3)").css('background-color', color1);
                    $("#" + id + " td:nth-child(" + (index + 1) + "):even:lt(-3)").css('background-color', color2);
                })

            }
        }
    }

    if ($('body').hasClass('vyhledavani') && $('.search-menu ul').length > 1) {
        $('.search-menu ul').addClass('hidden');
        $('.search-menu ul#list-all').removeClass('hidden');
    }



    /*-- #PROJECT GALLERY SUBMENU CONTROLLER --*/
    $('#projektovaGalerie .section-support-menu a[href*=#], #zakaznici .section-support-menu a[href*=#], #testimonials .section-support-menu a[href*=#]').on('click', function (event) {
        if (($('body').hasClass('projektovaGalerie') || $('body').hasClass('zakaznici') || $('body').hasClass('testimonials')) && !($mobile)) {
            event.preventDefault();
            $('.active').removeClass('active');
            var $clicked_link = $(this);
            $clicked_link.addClass('active');
            var href = $.attr(this, 'href');
            $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 500, function () {
                window.location.hash = href;
            });
            return false;
        }
    });

    $(document).on('click', '.mobile--menu a', function (event) {
        event.preventDefault();
        if ($('body').hasClass('menu')) {
            $('body').removeClass('menu');
        } else {
            $('body').addClass('menu');
        }
    });


    /*-- #ING-MANUALS SHOW TABS BY SELECTED LANGUAGE --*/
    $(document).on('change', 'select[name="lang"]', function (event) {
        if ($('body').hasClass('ingmanualy')) {
            var searchfortab = $(this).val();
            var $panels = $(this).closest('.language-tabs').find('.tab-panel');
            $panels.each(function () {
                var thisid = $(this).attr('id');
                if (searchfortab == thisid) {
                    $(this).css('display', 'block');
                } else {
                    $(this).css('display', 'none');
                }
            });
        }
    });


    /*-- #PRODUCT DETAIL SENDING LINK ON MOBILE VERSION --*/
    $(document).on('click touchstart', '.section-mdownload.mobile button', function (event) {
        event.preventDefault();
        if ($(this).prop('disabled')) {
            return 1;
        }
        $(this).prop('disabled', true);

        if (window.grecaptcha) {
            grecaptcha.ready(function () {
                var key = $("meta[name=captcha-key]").attr('content');
                var action = 'downloadMobile';
                grecaptcha.execute(key, { action: action }).then(function (token) {
                    $("input[name=grecaptcharesponse]").val(token);
                    var formData = $(".section-mdownload.mobile button").closest('form').serialize();
                    var url = $(".section-mdownload.mobile button").closest('form').attr('action');
                    $.ajax({
                        dataType: "json",
                        url: url,
                        data: formData,
                        success: function (data) {
                            $('.message p').hide();
                            $('.message p.message_' + data.result).show();
                            $('.message').addClass('active');
                            if (data.result != "1") {
                                $(".section-mdownload.mobile button").prop('disabled', false);
                            } else {
                                $(".section-mdownload.mobile").css("display", "none");
                            }
                        }
                    });
                });
            });
        }
    });

    /*-- #CLOSE MODAL MESSAGE --*/
    $(document).on('click', '.message', function (event) {
        $(this).removeClass('active');
    });


    /*-- FLOATING MENU ON #PRODUCT CONTROLLER --*/
    $(document).on('click', '.section-float-menu a', function (event) {
        var offset = $(this).attr('href').replace('#', '');
        offset = parseInt($('#' + offset).offset().top)
        $("html, body").animate({ scrollTop: (offset - 100) + 'px' }, 800);
    });


    /*-- CART MENU FOR SMALLER DEVICES --*/

    var $mobilecart = $("li.item.cart .menu").clone();
    $mobilecart.attr("id", "my-mobile-cart");

    $mobilecart.mmenu({
        autoHeight: true,
        extensions: ['effect-slide-menu'],
        offCanvas: {
            position: "right"
        }
    });
    // var APICart = $('#my-mobile-cart').data( "mmenu" );

    /*-- USER MENU FOR SMALLER DEVICES --*/

    var $mobileuser = $("li.item.user .user-menu").clone();
    $mobileuser.attr("id", "my-mobile-login");

    $mobileuser.mmenu({
        autoHeight: true,
        extensions: ['effect-slide-menu'],
        offCanvas: {
            position: "right"

        }
    });



    /*-- MAIN MENU FOR SMALLER DEVICES --*/
    var $menuMain = $('.menu-main li.item').clone();
    var $menuInfo = $('.menu-info li.languages').clone();
    var $menuCurrency = $('.menu-info li.currency').clone();
    var $menuRight = $('.menu-right').clone();
    var $menuGeo5 = $('#menu-tab-geo5').clone();
    var $menuFinec = $('#menu-tab-finec').clone();
    var $menuTruss = $('#menu-tab-truss').clone();
    var $menu = $(document.createElement('div'));
    var $menuSupport = $menuMain.find("li.item");
    $menu.append('<ul class="mobile-menu"></ul>');
    // $menu.find('.mobile-menu').append($menuMain).append($menuInfo);
    $menu.find('.mobile-menu').append($menuGeo5).append($menuFinec).append($menuTruss).append($menuInfo).append($menuCurrency).append($menuRight);
    $menu.attr("id", "my-mobile-menu");
    $menu.mmenu({
        extensions: ['effect-slide-menu'],
        offCanvas: { position: "right" },
        pageSelector: ".content"
    });
    var API = $menu.data("mmenu");
    var $logo = $('.mobile-header .logo a').clone();
    $logo.attr('id', 'cloned_logo');
    var $menuCart = $('.mobile--cart').clone();
    var $menuUser = $('.mobile--user').clone();
    var $menuSearch = $('.mobile--search').clone();
    $('.mm-navbar').append($menuCart).append($menuSearch).append($menuUser).prepend($logo);


    /*-- SEARCH MENU FOR SMALLER DEVICES --*/
    $("#my-mobile-search").mmenu({
        offCanvas: {
            position: "top",
            zposition: "front"
        }
    });
    var APISearch = $("#my-mobile-search").data("mmenu");


    /*-- SUBMENU ON #SUPPORT PAGE FOR SMALLER DEVICES --*/
    if ($('body').hasClass('OnlineSupport')) {
        var $submenu = $('.menutemplate').clone();
        $submenu.attr("id", "my-support-menu");
        $submenu.removeClass('hidden');
        $submenu.mmenu({
            extensions: ['effect-slide-menu'],
            offCanvas: { position: "left" }
        });
        var APISubmenu = $submenu.data("mmenu");
    }


    /*-- WRAP ALL IMAGES TO LINK FOR LIGHTBOX CAUSE NOT CHANGING ADMIN DATA --*/
    /*    if($('body').hasClass('OnlineSupport')){
            $('.support-container img').each( function() {
                var $img = $(this),
                    href = $img.attr('src');
                $img.wrap('<a href="' + href + '" class="link" rel="lightbox"></a>');
            });
        }
    */

    /*-- FLOATING MENUS ON #SUPPORT CONTROL --*/
    $(document).on('click', '#OnlineSupport .support-menu', function (event) {
        event.preventDefault();
        if ($('.rolled').length) {
            $('.rolled').parent().find('.submenu').stop().slideUp(100);
            $('.rolled').removeClass('rolled');
            $(this).parent().find('.submenu').stop().slideDown(100);
            $(this).addClass('rolled');
        } else {
            $(this).parent().find('.submenu').stop().slideDown(100);
            $(this).addClass('rolled');
        }
    });

    $(document).on('click', '#OnlineSupport .submenu a', function (event) {
        event.preventDefault();
        if ($('.xrolled').length) {
            $('.xrolled').parent().find('.subsubmenu').stop().slideUp(100);
            $('.xrolled').removeClass('xrolled');
            $(this).parent().find('.subsubmenu').stop().slideDown(100);
            $(this).addClass('xrolled');
        } else {
            $(this).parent().find('.subsubmenu').stop().slideDown(100);
            $(this).addClass('xrolled');
        }
    });


    /*-- ROLLDOWN LIST ON #CONTACT PAGE--*/
    $(document).on('click', '.contact-adress li a, .text-toggle', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('rolled')) {
            $(this).parent().find('.submenu').stop().slideDown(100);
            $(this).addClass('rolled');
        } else {
            $(this).parent().find('.submenu').stop().slideUp(100);
            $(this).removeClass('rolled');
        }
    });


    /*-- ROLLDOWN ON PAGES FROM ADMIN --*/
    $(document).on('click', '.slide-toggle', function (event) {
        event.preventDefault();
        if (!$(this).hasClass('rolled')) {
            $(this).parent().next('.slide-block').stop().slideDown(100);
            $(this).addClass('rolled');
        } else {
            $(this).parent().next('.slide-block').stop().slideUp(100);
            $(this).removeClass('rolled');
        }
    });


    /*-- SUBMITS FORM ON CHANGE SELECTBOX --*/
    $(document).on('change', 'select[data-action=submit]', function (event) {
        event.preventDefault();
        $(this).closest('form').submit();
    });


    /*-- SENDING SEARCHTERM AND HASH TO SEARCH PAGE FROM PRODUCT DETAIL --*/
    $(document).on('click', '#detailhelp', function (event) {
        event.preventDefault();
        $("#detailhelpform").attr("action", $("#detailhelpform").attr("action") + "?text=" + $("#detailhelptext").val() + "#help");
        $("#detailhelpform").submit();
    });

    /*-- #SCROLL TO TAB WHEN SELECTED CONTINENT --*/
    if ($('body').hasClass('prodejci') && $('#hiddenRegion').val() == "1") {
        $("html, body").animate({ scrollTop: ($('#tabs').offset().top - 100) }, 800);
    }

    /*-- # OWL CAROUSEL INIT for (GEO5 save your time)+ ADDING CONTROLS --*/
    if ($('body').hasClass('product') && !$('body').hasClass('uvod')) {
        var $carousel = $(".section-product-images .wrapper").clone();
        var $ArrowDivLeft = $('<div></div>').addClass("arrow").addClass("arrow-left");
        var $ArrowDivRight = $('<div></div>').addClass("arrow").addClass("arrow-right");
        $carousel.attr('id', 'my-mobile-carousel');
        $(".section-product-images").append($carousel)
        $('#my-mobile-carousel').find('.product-column--free').remove();
        $('#my-mobile-carousel').owlCarousel({ margin: 20 });
        $('#my-mobile-carousel').prepend($ArrowDivLeft).append($ArrowDivRight);
    }

    $('.carousel-wrapper .wrapper').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="21" height="38" viewBox="0 0 21 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0651 37.5095L20.6492 36.9254C21.0363 36.5384 21.0363 35.9107 20.6492 35.5236L4.50083 19.3751L20.6492 3.22668C21.0363 2.8396 21.0363 2.21198 20.6492 1.82482L20.0651 1.24081C19.678 0.853731 19.0504 0.853731 18.6633 1.24081L1.22982 18.6742C0.842744 19.0613 0.842744 19.6889 1.22982 20.0761L18.6633 37.5095C19.0504 37.8966 19.678 37.8966 20.0651 37.5095Z" fill="currentColor"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="21" height="38" viewBox="0 0 21 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81391 1.24012L1.22982 1.82413C0.842744 2.21121 0.842744 2.83883 1.22982 3.22599L17.3782 19.3744L1.22982 35.5229C0.842744 35.91 0.842744 36.5376 1.22982 36.9248L1.81391 37.5088C2.20099 37.8958 2.82861 37.8958 3.21569 37.5088L20.6492 20.0753C21.0363 19.6883 21.0363 19.0606 20.6492 18.6735L3.21569 1.24012C2.82861 0.852962 2.20099 0.852962 1.81391 1.24012Z" fill="currentColor"/></svg></button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    });

    if ($(".feature-carousel__slick").length) {
        $(".feature-carousel__slick").slick({
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="21" height="38" viewBox="0 0 21 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0651 37.5095L20.6492 36.9254C21.0363 36.5384 21.0363 35.9107 20.6492 35.5236L4.50083 19.3751L20.6492 3.22668C21.0363 2.8396 21.0363 2.21198 20.6492 1.82482L20.0651 1.24081C19.678 0.853731 19.0504 0.853731 18.6633 1.24081L1.22982 18.6742C0.842744 19.0613 0.842744 19.6889 1.22982 20.0761L18.6633 37.5095C19.0504 37.8966 19.678 37.8966 20.0651 37.5095Z" fill="currentColor"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="21" height="38" viewBox="0 0 21 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.81391 1.24012L1.22982 1.82413C0.842744 2.21121 0.842744 2.83883 1.22982 3.22599L17.3782 19.3744L1.22982 35.5229C0.842744 35.91 0.842744 36.5376 1.22982 36.9248L1.81391 37.5088C2.20099 37.8958 2.82861 37.8958 3.21569 37.5088L20.6492 20.0753C21.0363 19.6883 21.0363 19.0606 20.6492 18.6735L3.21569 1.24012C2.82861 0.852962 2.20099 0.852962 1.81391 1.24012Z" fill="currentColor"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }

    /*-- #PRODUCT OWL CAROUSEL INIT + ADDING CONTROLS --*/
    if ($('body').hasClass('product') && !$('body').hasClass('uvod')) {
        // var $carousel = $(".section-product-images .wrapper").clone();
        // var $ArrowDivLeft = $('<div></div>').addClass("arrow").addClass("arrow-left");
        // var $ArrowDivRight = $('<div></div>').addClass("arrow").addClass("arrow-right");
        // $carousel.attr('id','my-mobile-carousel');
        // $(".section-product-images").append($carousel)
        // $('#my-mobile-carousel').find('.product-column--free').remove();
        $('#my-mobile-carousel').owlCarousel({ margin: 20 });
        $('#my-mobile-carousel').prepend($ArrowDivLeft).append($ArrowDivRight);
    }

    /*-- #PACKAGES OWL CAROUSEL INIT + ADDING CONTROLS --*/
    if ($('body').hasClass('packages-page')) {
        var $carousel = $(".section-product-images .packages-wrapper").clone();
        var $ArrowDivLeft = $('<div></div>').addClass("arrow").addClass("arrow-left");
        var $ArrowDivRight = $('<div></div>').addClass("arrow").addClass("arrow-right");
        $carousel.attr('id', 'packages-carousel');
        $(".section-product-images").append($carousel);
        $('#packages-carousel').find('.product-column--free').remove();
        $('#packages-carousel').owlCarousel({ margin: 20 });
        $('#packages-carousel').prepend($ArrowDivLeft).append($ArrowDivRight);
    }

    if ($('[data-component="languageSwitch"]').length) {
        $('.languageSwitch a').click(function () {
            event.preventDefault();
            var current = $(this).data('currency');

            $('.languageSwitch a').removeClass('active');
            $('.languageSwitch a[data-currency="' + current + '"]').addClass('active');

            $('strong[data-currency]').hide();
            $('strong[data-currency="' + current + '"]').show();
            $('span[data-currency]').hide();
            $('span[data-currency="' + current + '"]').show();

            //replace currency anchor
            $('.section-properties a').each(function () {
                var href = $(this).attr('href');
                if (href.indexOf("#") != -1) {
                    href = href.substring(0, href.length - 4) + "_" + current;
                    $(this).attr('href', href);
                }
            })

            //call currency switch on shop
            changeShopCurrency(current);
        })
    }

    if ($('[data-component="accordeon"]').length) {
        var $accordeon = $('[data-component="accordeon"]');
        var $accordeon_items = $accordeon.children('.accordeon-item');
        var $accordeon_nav_items = $('a[data-package]');
        var hash = $(location).attr('hash').split('#').pop();

        // Check for has in url and select active item
        if (hash) {
            $accordeon_items.each(function (index) {
                if ($($accordeon_items[index]).data('id') == hash) {
                    $accordeon_items.removeClass('active');
                    $($accordeon_items[index]).addClass('active');

                    $accordeon_nav_items.removeClass('active');
                    $('a[data-package="' + $($accordeon_items[index]).data('id') + '"]').addClass('active');
                }
            });
        }

        if ($(document).innerWidth() < 1024) {
            $accordeon_items.each(function (index) {
                $($accordeon_items[index]).find('.accordeon-body').css('max-height', ($($accordeon_items[index]).find('.accordeon-body').prop('scrollHeight') + 20) + 'px');
            });
        } else {
            $accordeon.css('height', ($accordeon_items[0].scrollHeight + 20) + 'px');
        }

        // Click event for desktop
        $accordeon_nav_items.click(function (event) {
            $accordeon_nav_items.removeClass('active');
            $(this).addClass('active');

            $accordeon_items.removeClass('active');
            $('.accordeon-item[data-id=' + $(this).data('package') + ']').addClass('active');
        })

        // Click event for mobile
        $('.accordeon-header').click(function (event) {
            event.preventDefault();

            var header = $(this)
            setTimeout(function () {
                $('html, body').scrollTop(header.offset().top - 40);
            }, 50)

            $accordeon_items.removeClass('active');
            $(this).closest('.accordeon-item').addClass('active');
        })

        // Resize event
        $(window).resize(function () {
            if ($(window).innerWidth() < 1024) {
                $accordeon_items.each(function (index) {
                    $($accordeon_items[index]).find('.accordeon-body').css('max-height', ($($accordeon_items[index]).find('.accordeon-body').prop('scrollHeight') + 20) + 'px');
                });
            } else {
                $accordeon.css('height', ($accordeon_items[0].scrollHeight + 20) + 'px');
            }
        })
    }


    /*-- #SUPPORT OWL CAROUSEL LISTENERY --*/
    $(document).on('click', '#my-mobile-carousel .arrow-left', function (event) {
        var owl = $(".owl-carousel").data('owlCarousel');
        owl.prev();
    });
    $(document).on('click', '#my-mobile-carousel .arrow-right', function (event) {
        var owl = $(".owl-carousel").data('owlCarousel');
        owl.next();
    });

    $(document).on('click', '#packages-carousel .arrow-left', function (event) {
        var owl = $(".owl-carousel").data('owlCarousel');
        owl.prev();
    });
    $(document).on('click', '#packages-carousel .arrow-right', function (event) {
        var owl = $(".owl-carousel").data('owlCarousel');
        owl.next();
    });

    /*-- #PACKAGES OWL CAROUSEL INIT + ADDING CONTROLS --*/



    /*-- #TESTIMONIALS CAROUSEL--*/
    if ($(".testimonial-carousel").length) {
        $(".testimonial-carousel").owlCarousel({
            singleItem: true,
            center: true,
            autoPlay: 20000,
            stopOnHover: true
        });
        var owl = $(".testimonial-carousel").data('owlCarousel');
        owl.jumpTo(Math.floor((Math.random() * 3)));
    }

    /*-- #HOMEPAGE CAROUSEL--*/
    if ($(".introduction-carousel").length) {
        $(".introduction-carousel").owlCarousel({
            singleItem: true,
            autoPlay: 3000,
            center: true,
            stopOnHover: true
        });
    }


    /*-- #FEATURE CAROUSEL--*/
    if ($(".feature-carousel").length) {
        $(".feature-carousel").owlCarousel({
            singleItem: true,
            pagination: true,
            autoPlay: 3000,
            center: true,
            stopOnHover: true,
            navigation: true,
            transitionStyle: "fade",
            navigationText: [
                '<span class="nav-btn prev-slide" aria-hidden="true"></span>',
                '<span class="nav-btn next-slide" aria-hidden="true"></span>'
            ]
        });
    }


    /*-- #DEALER SELECTOR --*/
    $(document).on('click', '#prodejci .section-support-menu-oneLevel a', function (event) {
        event.preventDefault();
        var country = $(this).attr('href').substr(1);
        $(".section-support-menu-oneLevel .active").removeClass('active');
        $(this).addClass('active');
        $(".dealer-list.preferred .countrylabel").html($(this).text());
        $(".dealer-list.preferred").removeClass("hidden");
        $(".dealer-list.preferred .dealer-item").remove();
        $(".dealer-item:not(.preferred)").each(function (index) {
            $(this).find('.countries span').each(function (index) {
                if ($(this).data('rel') == country) {
                    var preferred = $(this).closest('.dealer-item').clone();
                    $(".dealer-list.preferred").append(preferred);
                }
            });
        });
        $('html,body').animate({ scrollTop: $(".dealer-list.preferred h2").offset().top }, 500);
    });


    /*--  MENU CONTROLLER --*/
    var timer;
    var delay = 200;

    $('.menu .item .menu-label').hover(function () {
        menuElement = $(this);
        timer = setTimeout(function () {
            if (width >= 700 && !menuElement.hasClass('no-menu')) {
                $('.thismenuopened').removeClass('thismenuopened');
                menuElement.addClass('thismenuopened');
                adaptMenu();

                // IF MENU IS SEARCH THEN INSERT SEARCHED VALUE AND FOCUS
                if (menuElement.hasClass('icon-search')) {
                    $('#menushaker').find('.searchfield').val($searchfield).focus();
                }
            } else {
                $('#menushaker').css('opacity', 0);
            }
        }, delay);

    }, function () {
        // on mouse out, cancel the timer
        clearTimeout(timer);
    });

    $(document).on('input', '#menushaker .searchfield', function (event) {
        $searchfield = $(this).val();
    });

    $(document).on('mouseleave', '.site-nav', function (event) {
        $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
        $('.thismenuopened').removeClass('thismenuopened');
    });

    $(document).on('click touchend', '.content', function (event) {
        $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
        $('.thismenuopened').removeClass('thismenuopened');
    });

    $(document).on('mouseenter', '.site-nav', function (event) {
        $('li.item').addClass('hiddenmenu');
    });

    $(document).on('mouseleave', '.site-nav', function (event) {
        $('li.item').removeClass('hiddenmenu');
    });

    $(document).on('click', '.help-menu-settings a', function (event) {
        $('.filters').slideToggle();
        $(this).parent().toggleClass('active');
    });

    $(document).on('click', '.help-menu-mobile a', function (event) {
        $(this).parent().toggleClass('active');
    });


    /*-- CHANGE ICONS ON CLOSING MOBILE MENUS --*/
    function checkClosing() {
        if ($('.mobile--main a').hasClass('enable')) {
            $('.mobile--main a').removeClass('icon-close');
            $('.mobile--main a').removeClass('enable');
            $('.mobile--main a').addClass('icon-mobile-menu-2');
        }
        if ($('.mobile--search a').hasClass('enable')) {
            $('.mobile--main a').removeClass('icon-close');
            $('.mobile--main a').removeClass('enable');
            $('.mobile--main a').addClass('icon-mobile-menu-2');
        }
        if ($('.mobile--cart a').hasClass('enable')) {
            $('.mobile--main a').removeClass('icon-close');
            $('.mobile--main a').removeClass('enable');
            $('.mobile--main a').addClass('icon-mobile-menu-2');
        }
        if ($('.mobile--login a').hasClass('enable')) {
            $('.mobile--main a').removeClass('icon-close');
            $('.mobile--main a').removeClass('enable');
            $('.mobile--main a').addClass('icon-mobile-menu-2');
        }
    }



    /*-- ADAPT MAP TO SMALLER SCREENS --*/
    function adaptMap() {
        var $window = $(window);
        var width = $window.width();
        var height = $window.height();
        var scale;
        if (width >= maxWidth && height >= maxHeight) {
            $('.dealer-map').css({ '-webkit-transform': '' });
            $('.dealer-map').css({ '-moz-transform': '' });
            $('.dealer-map').css({ '-ms-transform': '' });
            $('.dealer-map ul').css({ width: '', height: '' });
            return;
        }
        scale = Math.min(width / maxWidth, height / maxHeight);
        $('.dealer-map').css({ '-webkit-transform': 'scale(' + scale + ')' });
        $('.dealer-map').css({ '-moz-transform': 'scale(' + scale + ')' });
        $('.dealer-map').css({ '-ms-transform': 'scale(' + scale + ')' });
        $('.dealer-map').css({ 'transform-origin': '0 0' });
        $('.dealer-map ul').css({ width: maxWidth * scale, height: maxHeight * scale });
    }

    /*-- ADAPTING MENU TO ALL RESOLUTIONS --*/
    function adaptMenu() {
        if ($('.thismenuopened').length) {
            var $menucontent = $('.thismenuopened').parent().find('.menu').clone();
            var $unimenu = $('#menushaker');
            var $menuwidthhalf = parseInt($('.thismenuopened').data('width')) / 2;
            var $needoffset = parseInt($('.thismenuopened').data('offset'));
            var $top = ((parseInt($('.thismenuopened').offset().top) - window.scrollY) + (parseInt($('.thismenuopened').outerHeight(true))) - 1);
            var $right = ($(window).width() - ($('.thismenuopened').offset().left + $('.thismenuopened').outerWidth(true)) - $menuwidthhalf - $needoffset);

            //setTimeout(function(){  }, 3000);

            $unimenu.html("");
            $unimenu.css('top', $top + 'px');
            $unimenu.css('opacity', 0.5);
            $unimenu.append($menucontent).css('visibility', 'visible');
            $unimenu.css('opacity', 1);
            $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')))) + 'px');

            if (width >= 1024) {
                if ($right + parseInt($('.thismenuopened').data('width')) < width) {
                    $unimenu.css('width', parseInt($('.thismenuopened').data('width')) + 'px');
                    $unimenu.css('right', $right + 'px');
                } else {
                    $unimenu.css('width', parseInt($('.thismenuopened').data('width')) + 'px');
                    $unimenu.css('right', width - parseInt($('.thismenuopened').data('width')) + 'px');
                    $unimenu.find('.triangle').css('left', '400px');
                }
            } else {
                if ($('.thismenuopened').data('width') == "1024") {
                    $unimenu.css('width', '100%');
                    $unimenu.css('right', 0);
                    $unimenu.find('.triangle').css('left', $('.thismenuopened').offset().left + parseInt($('.thismenuopened').data('tablet')) + 'px');
                } else {
                    $unimenu.css('width', $('.thismenuopened').data('width') + 'px');
                    $unimenu.css('right', $right + 'px');
                }
            }

            if ($('.thismenuopened').parent().find('.menu').hasClass('learning') && $('.thismenuopened').parent().find('.menu').hasClass('lastitem') && $device == "projector") {
                $unimenu.css('right', ($right - 375) + 'px');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) + 375)) + 'px');
            }



            if ($('.thismenuopened').parent().find('.menu').hasClass('fin') && $device == "tablet") {
                $unimenu.css('right', ($right - 90) + 'px');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) + 160)) + 'px');

            }
            //support adjustments
            if ($('.thismenuopened').parent().find('.menu').hasClass('help') && $device == "tablet") {
                $unimenu.css('right', '0');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) - 90)) + 'px');
            }
            if ($('.thismenuopened').parent().find('.menu').hasClass('help') && $device == "lg") {
                $unimenu.css('right', '0');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) - 70)) + 'px');

            }
            if ($('.thismenuopened').parent().find('.menu').hasClass('help') && $device == "xl") {
                $unimenu.css('right', ($right + 40) + 'px');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) - 45)) + 'px');
            }
            //cart adjustments
            if ($('.thismenuopened').parent().find('.menu').hasClass('cart') && $device == "lg") {
                $unimenu.css('right', ($right + 5) + 'px');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) - 25)) + 'px');
            }

            if ($('.thismenuopened').parent().find('.menu').hasClass('shop') && $('.thismenuopened').parent().find('.menu').hasClass('lastitem') && $device == "tablet") {
                $unimenu.css('right', ($right - 125) + 'px');
                $unimenu.find('.triangle').css('left', ($menuwidthhalf - (parseInt($unimenu.find('.triangle').data('offset')) + 125)) + 'px');
            }

            var xwidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if ($('.thismenuopened').parent().find('.menu').hasClass('geo5') && xwidth >= 1920) {
                $unimenu.find('.triangle').css('left', '490px');
            }
        }
    }


    /*-- ADAPTING BACKGROUND WHEN SMALLER SCREEN IS USED --*/
    function adaptBG() {
        var width = $(window).width();
        var pattern = $('.homepage-background-pattern');
        var backgro = $('.homepage-background-image');
        var howmany = (width - 1300) / 2;
        var multiplier = 1;

        if (width < 768) {
            multiplier = 500;
        } else if (width >= 768 && width < 1240) {
            multiplier = 0;
        } else if (width > 1024 && width < 1903) {
            multiplier = -275;
        } else {
            multiplier = 0;
        }

        if (width > 1240) {
            pattern.css('left', (howmany + multiplier) + 'px');
            backgro.css('right', (howmany - multiplier) + 'px');
        }
    }


    /*-- DETECT DEVICE RESOLUTION --*/
    function deviceDetect() {
        if (window.innerWidth < 768) {
            $device = "mobile";
        } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
            $device = "tablet";
        } else if (window.innerWidth > 1025 && window.innerWidth < 1199) {
            $device = "lg";
            // console.log("lg")
        } else if (window.innerWidth > 1200 && window.innerWidth < 1400) {
            $device = "xl";
            // console.log("xl")
        } else if (window.innerWidth > 1400 && window.innerWidth < 1600) {
            $device = "xxl";
        } else if (window.innerWidth > 1600 && window.innerWidth < 1928) {
            $device = "xxxl";
        } else if (window.innerWidth > 1025 && window.innerWidth < 1928) {
            $device = "desktop";
        } else {
            $device = "projector";
        }

        if (window.innerWidth > 680) {
            API.close();
            APISearch.close();
            if (typeof APICart !== 'undefined') {
                APICart.close();
            }

            checkClosing();
        }

        if (window.innerWidth < 768 && $('body').hasClass('OnlineSupport')) {
            APISubmenu.close();
            checkClosing();
        }


    }


    /*-- GETTING OFFSET OF FLOATING ELEMENTS --*/
    function offsetMenu() {
        //   if($floatmenu.length){ offset = parseInt($floatmenu.offset().top) - 40; }
    }

    function adapt() {
        var $olddevice = $device;
        deviceDetect();
        adaptMenu();
        adaptBG();
        adaptProperties();
        offsetMenu();
        if (
            $('body').hasClass('aboutus') ||
            $('body').hasClass('prodejci') ||
            $('body').hasClass('zakaznici') ||
            $('body').hasClass('testimonials')
        ) { adaptMap(); }
        if (($device != $olddevice) || (!loaded)) {
            var $menuMain = $('#main-menu .menu-main').first().clone();
            //       $('#main-menu .menu-main').first().remove();
            $menuMain.attr('id', 'menu-main-clone');
        }

        if (!loaded) {

            /*-- LOADING LIGHTBOX --*/
            if (width >= 767) {
                $('[rel="lightbox"]').lightbox();
                $('[rel="lightboxNOLOOP"]').lightbox({ cyclic: false });
                $('[rel="lightboxNOLOOPSMALL"]').lightbox({ cyclic: false });
                $('.support-container-galerie .item .img').find('a').lightbox();
            } else {
                $('[rel="lightbox"]').swipebox({ loopAtEnd: true });
                $('[rel="lightboxNOLOOP"]').swipebox({ loopAtEnd: true });
                $('[rel="lightboxNOLOOPSMALL"]').swipebox({ loopAtEnd: true });
                $('.support-container-galerie .item .img').find('a').swipebox({ loopAtEnd: true });
            }
            /*-- LOADING SELECTBOX --*/
            $('select:not(.form-country-select):not(#frm-country):not(#frm-quantity):not(#frm-maintenance):not(.uploaded-files):not(.no-selectbox)').selectbox({ effect: 'slide' });
            loaded = true;

        }

    }

    //change additional language functionality
    $(document).ready(function () {
        $('#change_language_flag').click(function (event) {
            event.preventDefault();
            var applyLang = $(this).attr('data-language-flag');
            var select = $('#form-help-language');
            var form = $('.form-support-filter');
            if (select.length && form.length && applyLang.length) {
                select.val(applyLang);
                form.submit();
            }
        });
    });
    //apply online help images the lightbox
    $(document).ready(function () {
        $(".ajaxwrapper .center img").each(function () {
            var img = $(this);
            // Create dummy image to get real width and height
            var caption = img.closest('p').find('.img-desc').text();

            $("<img>").attr("src", img.attr("src")).attr("source-width", img.width()).attr('data-caption', caption).load(function () {
                var realWidth = this.width;
                var width = parseInt($(this).attr('source-width'));
                if (realWidth > width) {
                    var tmpImg = img.clone();
                    var $link = $("<a>").attr('href', $(this).attr('src'))
                        .attr('class', 'image-link-pointer')
                        .attr('data-caption', $(this).attr('data-caption'))
                        .attr('rel', 'lightboxNOLOOP');
                    $link.html(tmpImg);
                    $link.append("<div class=\"help-image-overlay\">\n" +
                        "  <span class=\"icon icon-search\"> </span>\n" +
                        "  </div>")
                    var $div = $("<div>").attr('class', 'help-image-container');
                    $div.html($link);
                    img.replaceWith($div);
                    $link.lightbox();
                }
            });
        });
    });


    // Cart.init();
    deviceDetect();
    $(document).ready(adapt);
    $(document).ready(loadCartItems('', '', 'refresh'));
    $(window).resize(adapt);

    $(document).ready(function () {
        $(document).on("click", ".removeProgramItem", function () {
            var elem = this;
        });
    });


    function renderCartProduct(label, quantity, extraText, price, program, type) {
        var title = label;
        var removeBtn = '';
        if (quantity && type) {
            title = title + ' - ' + quantity + ' ' + extraText;
            // removeBtn = '<div class="menu--controls"><a href="/?remove" class="icon icon-remove removeCartButton" data-action="remove"></a></div>';
            // removeBtn = '<div class="menu--controls"><a href="javascript:;" data-program="'+program+'" data-program-type = "'+type+'" class="icon icon-remove removeCartButton" data-action="remove"></a></div>';
        }
        return '<li><div class="menu--title"><span class="mnuCart">' + title + '</span></div><div class="menu--price"><span class="mnuCart"><span>' + price + '</span></span><a href="#" class="close"></a></div>' + removeBtn + '</li>';
    }

    function loadCartItems(program, type, action) {
        // return 1;
        var data = {};
        var uriData = {};
        if (action != 'refresh') {
            var uriData = { product_id: program, type: type, action: action };
        }

        var cartContainer = $('.cart-items');
        var emptyCartContainer = $('.emptycart');
        var cartHTML = '';
        var apiUrl = $('#cartDropdown').attr('data-api-url');
        var cartCount = 0;
        $('.cart-items').hide();
        newCart.init();

    }

})();


$('#my-support-menu .mm-panel').prepend('<div class="title-holder cloned">' + $('.header-help .title-holder').html() + '</div>');
$('#frm-anti').val('finesoftware');


/*-- CART ADDING AND REMOVING LISTENERS --*/
$(document).on('click', '.buy-button-list li a', function (event) {
    event.preventDefault();
    newCart.init();
});

$(document).on('click', '.removeCartButton', function (event) {
    event.preventDefault();
    var parentLi = $(this).parent().parent();
    newCart.deleteCartItem(parentLi.attr('data-id'));
    newCart.init();
    parentLi.slideUp(100);
});

newCart.init();


$(".captchaSubmit").click(function (event) {
    event.preventDefault();
    if (window.grecaptcha) {
        grecaptcha.ready(function () {
            var key = $("meta[name=captcha-key]").attr('content');
            var action = $(".captchaSubmit").attr('data-action');
            grecaptcha.execute(key, { action: action }).then(function (token) {
                $("input[name=grecaptcharesponse]").val(token);
                $('.captcha-form').submit();
            });
        });
    } else {
        $('.captcha-form').submit();
    }
});


//preferred dealer
$(function () {
    $('#form-demo-country').on('change', function () {
        var selected = this;
        if (typeof window.preferredDealers[selected.value] !== 'undefined') {
            $('#form-demo-preferred_dealer').closest('p').show();
            $('#form-demo-preferred_dealer option[value="X"]').remove();
            //remove old options from select, keep only any and --select
            $('#form-demo-preferred_dealer option').each(function () {
                if (!($(this).val() == '' || $(this).val() == 'any')) {
                    $(this).remove();
                }
            });
            //add new options to select
            Object.keys(window.preferredDealers[selected.value]).forEach(function (key) {
                $("#form-demo-preferred_dealer").append(new Option(window.preferredDealers[selected.value][key], key));
            });
        } else {
            $('#form-demo-preferred_dealer').closest('p').hide();
        }
    });
    $(".sticky-bar__cta").click(function (event) {
        event.preventDefault();
        $(this).parent().toggleClass('active');
    });
});



//set current currency as active in language switch
$(function () {
    var x = getCurrencyCookie();
    if (x) {
        if ($(".languageSwitch")[0]) {
            $('.languageSwitch a').removeClass('active');
            $('.languageSwitch a[data-currency="' + x.toLowerCase() + '"]').addClass('active');
        }
        if ($(".priceListCurrency")[0]) {
            var elem = $('.priceListCurrency[data-currency="' + x.toLowerCase() + '"]');
            elem[0].click();
        }
    }

});

$(document).on("click", ".currencyItem", function () {
    event.preventDefault();
    var clicked = $(this);
    var currency = clicked.attr('data-currency');
    changeShopCurrency(currency);
    window.location.href = $(this).attr('href')
});

$(document).on("click", ".priceListCurrency", function () {
    var clicked = $(this);
    var currency = clicked.attr('data-currency');
    changeShopCurrency(currency);
});

function setCurrencyCookie(currency) {
    var date = new Date();
    date.setTime(date.getTime() + (10 * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toUTCString();
    newCart.init();
    document.cookie = 'currency=' + currency.toUpperCase() + expires + '; path=/';
}

function getCurrencyCookie() {
    var name = 'currency' + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function highlightProg() {
    $('.accordeon-sidemenu ul li a').on("mouseenter", function () {
        $('.packageList ul li').removeClass('active');
        $('.accordeon-sidemenu ul li a').removeClass('active');
        $(this).addClass('active');
        var data = $(this).attr('data-id');
        $('.packageList ul li a[data-id*=' + data + ']').parent().addClass('active');
    });
    $('.accordeon-sidemenu ul li a').on("mouseleave", function () {
        $('.packageList ul li a').parent().removeClass('active');
    });
}
highlightProg();

function changeShopCurrency(currency) {
    setCurrencyCookie(currency);

    $('.selectedCurrency').html(currency.toUpperCase());

    var apiUrl = $('#cartDropdown').attr('data-api-url');
    var uriData = { selected_currency: currency }
    $.getJSON(apiUrl, uriData, function (data) {
        return false;
    });
}
function changeSelectedProductMenu() {
    // $('.menu-tab').hover(function () {
    //     $(this).toggleClass('selected').siblings().removeClass('selected');
    // });

    $('.menu-tab').on('mouseover', function () {

        $('.menu-tab.active').removeClass('active');
        $('.menu-tab.selected').removeClass('selected');
        $(this).addClass('selected');
        $('#menushaker').css('opacity', '0').css('visibility', 'hidden');


    });
    $('.logo--inner').on('mouseover', function () {
        $('.menu-tab.selected').removeClass('selected');
        $('.menu-tab:first-child').addClass('selected');
    });
}
function changeMenuByProduct() {
    if (!$('body').hasClass("finec") || !$('body').hasClass("truss4")) {
        $('.menu-tab .geo5').parent().addClass('active');
    }
    if ($('body').hasClass("geo5")) {
        $('.menu-tab .truss, .menu-tab .fin').on('mouseout', function (e) {
            var opened = $(this).find(".thismenuopened");
            // console.log(opened);
            if (!opened.length > 0) {
                $(this).parent().removeClass('selected');
                $('.menu-tab .geo5').parent().addClass('selected');
                $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
                $('.thismenuopened').removeClass('thismenuopened');
            }
        });

    };
    if ($('body').hasClass("finec")) {

        $('.menu-tab .fin').parent().addClass('active');
        $('.menu-tab .truss, .menu-tab .geo5').on('mouseout', function (e) {
            var opened = $(this).find(".thismenuopened");
            // console.log(opened);
            if (!opened.length > 0) {
                $(this).parent().removeClass('selected');
                $('.menu-tab .fin').parent().addClass('selected');
                $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
                $('.thismenuopened').removeClass('thismenuopened');
            }
        });

    }
    if ($('body').hasClass("truss4")) {

        $('.menu-tab .truss').parent().addClass('active');
        $('.menu-tab .fin, .menu-tab .geo5').on('mouseout', function (e) {
            var opened = $(this).find(".thismenuopened");
            // console.log(opened);
            if (!opened.length > 0) {
                $(this).parent().removeClass('selected');
                $('.menu-tab .truss').parent().addClass('selected');
                $('#menushaker').css('opacity', '0').css('visibility', 'hidden');
                $('.thismenuopened').removeClass('thismenuopened');
            }
        });
    }
}
changeSelectedProductMenu();
changeMenuByProduct();

function mediaBoxConfig(url, index) {
    var service = {},
        matches;

    if (matches = url.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/)) {
        service.provider = "youtube";
        service.id = matches[2];
    } else if (matches = url.match(/https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/)) {
        service.provider = "vimeo";
        service.id = matches[3];
    } else {
        service.provider = "Unknown";
        service.id = '';
    }
    var embedLink;

    if (service.provider === 'youtube') {
        embedLink = 'https://www.youtube.com/embed/' + service.id;
    } else if (service.provider === 'vimeo') {
        embedLink = 'https://player.vimeo.com/video/' + service.id;
    } else {
        throw new Error("Invalid video URL");
    }

    var configObject = {
        sourceUrl: embedLink,
        triggerElement: "#" + index,
        progressCallback: function () {
            // console.log("Callback Invoked.");
        }
    };

    var video = new YoutubeOverlayModule(configObject);
    video.activateDeployment();

}

$(document).ready(function () {
    var overlay = $('body');
    /* handler */
    overlay.on("click", function (event) {
        if (event.target.tagName.toLowerCase() !== "iframe" && event.target.id === "youtubePlayerOverlay") {
            overlay.find("#youtubeOverlayCloser").trigger("click");
        }
    });

    $(".mediabox").each(function (index) {
        var mediabox = $(this);
        var id = 'mediabox-selector-' + index
        mediabox.attr('id', id);
        var video = mediaBoxConfig(mediabox.attr('href'), id);
    });

    $(".mediabox").click(function () {
        return false;
    });
});

$(function () {
    if ($('#solutions-main-content').html()) {
        var navigation = '';
        $('#solutions-main-content h4').each(function (index) {
            var el = $(this);
            var key = 'content-anchor-' + (index + 1);
            el.attr("id", key);

            navigation += '<li><a href="#' + key + '">' + el.text() + '</a></li>';
        });
        $('#solutions-navigation').html('<p><ul class="solutions-navigation">' + navigation + '</ul></p>');
        var hash = window.top.location.hash.substr(1);
        if (hash) {
            $('html,body').animate({ scrollTop: $('#' + hash).offset().top }, 'slow');
        }

    }
});

$(document).ready(function () {
    $(document).on('click', '.emptyCartButton', function (event) {
        event.preventDefault();
        window.localStorage.setItem('cart', JSON.stringify(emptyCart));
        newCart.init();
        $('.cartCount').hide();
    });
});

function openTab() {
    $('.tab-link').click(function () {
        $(".tab").removeClass('active');
        $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("active");
        $(".tab-link").removeClass('active');
        $(this).addClass('active');
    });
}
if (document.querySelector(".download-box--tabs, .sitemap404--tabs") !== null) {
    openTab();
}

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
!function (e, n, A) { function o(e, n) { return typeof e === n } function t() { var e, n, A, t, a, i, l; for (var f in r) if (r.hasOwnProperty(f)) { if (e = [], n = r[f], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (A = 0; A < n.options.aliases.length; A++)e.push(n.options.aliases[A].toLowerCase()); for (t = o(n.fn, "function") ? n.fn() : n.fn, a = 0; a < e.length; a++)i = e[a], l = i.split("."), 1 === l.length ? Modernizr[l[0]] = t : (!Modernizr[l[0]] || Modernizr[l[0]] instanceof Boolean || (Modernizr[l[0]] = new Boolean(Modernizr[l[0]])), Modernizr[l[0]][l[1]] = t), s.push((t ? "" : "no-") + l.join("-")) } } function a(e) { var n = u.className, A = Modernizr._config.classPrefix || ""; if (c && (n = n.baseVal), Modernizr._config.enableJSClass) { var o = new RegExp("(^|\\s)" + A + "no-js(\\s|$)"); n = n.replace(o, "$1" + A + "js$2") } Modernizr._config.enableClasses && (n += " " + A + e.join(" " + A), c ? u.className.baseVal = n : u.className = n) } function i(e, n) { if ("object" == typeof e) for (var A in e) f(e, A) && i(A, e[A]); else { e = e.toLowerCase(); var o = e.split("."), t = Modernizr[o[0]]; if (2 == o.length && (t = t[o[1]]), "undefined" != typeof t) return Modernizr; n = "function" == typeof n ? n() : n, 1 == o.length ? Modernizr[o[0]] = n : (!Modernizr[o[0]] || Modernizr[o[0]] instanceof Boolean || (Modernizr[o[0]] = new Boolean(Modernizr[o[0]])), Modernizr[o[0]][o[1]] = n), a([(n && 0 != n ? "" : "no-") + o.join("-")]), Modernizr._trigger(e, n) } return Modernizr } var s = [], r = [], l = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (e, n) { var A = this; setTimeout(function () { n(A[e]) }, 0) }, addTest: function (e, n, A) { r.push({ name: e, fn: n, options: A }) }, addAsyncTest: function (e) { r.push({ name: null, fn: e }) } }, Modernizr = function () { }; Modernizr.prototype = l, Modernizr = new Modernizr; var f, u = n.documentElement, c = "svg" === u.nodeName.toLowerCase(); !function () { var e = {}.hasOwnProperty; f = o(e, "undefined") || o(e.call, "undefined") ? function (e, n) { return n in e && o(e.constructor.prototype[n], "undefined") } : function (n, A) { return e.call(n, A) } }(), l._l = {}, l.on = function (e, n) { this._l[e] || (this._l[e] = []), this._l[e].push(n), Modernizr.hasOwnProperty(e) && setTimeout(function () { Modernizr._trigger(e, Modernizr[e]) }, 0) }, l._trigger = function (e, n) { if (this._l[e]) { var A = this._l[e]; setTimeout(function () { var e, o; for (e = 0; e < A.length; e++)(o = A[e])(n) }, 0), delete this._l[e] } }, Modernizr._q.push(function () { l.addTest = i }), Modernizr.addAsyncTest(function () { function e(e, n, A) { function o(n) { var o = n && "load" === n.type ? 1 == t.width : !1, a = "webp" === e; i(e, a && o ? new Boolean(o) : o), A && A(n) } var t = new Image; t.onerror = o, t.onload = o, t.src = n } var n = [{ uri: "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=", name: "webp" }, { uri: "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==", name: "webp.alpha" }, { uri: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA", name: "webp.animation" }, { uri: "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=", name: "webp.lossless" }], A = n.shift(); e(A.name, A.uri, function (A) { if (A && "load" === A.type) for (var o = 0; o < n.length; o++)e(n[o].name, n[o].uri) }) }), t(), a(s), delete l.addTest, delete l.addAsyncTest; for (var p = 0; p < Modernizr._q.length; p++)Modernizr._q[p](); e.Modernizr = Modernizr }(window, document);